/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import { FieldHelp } from '@/core/components/FieldHelp';

import { fieldErrorId } from '@/utils/fieldIds';

import { InputWrapperStyles } from '@/themes/globalStyles';

interface FormInputProps {
  backgroundcolor: string;
  children: React.ReactNode;
  error: () => string | false;
  fieldName: string;
  helpText?: string;
  isRequired?: boolean;
  isSelect?: boolean;
}

export const InputWrapper = ({
  backgroundcolor,
  children,
  error,
  fieldName,
  helpText,
  isRequired,
  isSelect,
}: FormInputProps) => (
  <InputWrapperStyles
    className="muster-input-wrapper"
    backgroundcolor={backgroundcolor}
    error={!!error()}
    hasHelp={!!helpText}
    isRequired={isRequired}
    isSelect={isSelect}
  >
    <label>
      {children}
    </label>
    {!!helpText && (
      <FieldHelp
        fieldName={fieldName}
        text={helpText}
      />
    )}
    <span
      id={fieldErrorId(fieldName)}
      aria-live="assertive"
      aria-atomic="true"
      className="muster-field-error"
    >
      {error() || ''}
    </span>
  </InputWrapperStyles>
);
